import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { CameraOnlineStatus } from "../models/camera-online-status";

@Injectable({
    providedIn: 'root'
})
export class CameraOnlineHistoryService {
    constructor(
        private readonly httpClient: HttpClient
    ) {}

    getCameraOnlineStatuses(): Promise<CameraOnlineStatus[]> {
        return lastValueFrom(this.httpClient
            .get<CameraOnlineStatus[]>("/api/cameras/onlinehistory/statuses/"));
    }

    getCameraOnlineStatus(vehicleId: number): Promise<CameraOnlineStatus> {
        return lastValueFrom(this.httpClient
            .get<CameraOnlineStatus[]>(`/api/cameras/onlinehistory/statuses?vehicleId=${vehicleId}`)
            .pipe(map((statuses) => {
                return statuses?.length >= 0
                    ? statuses[0]
                    : null
            })));
    }
}
